import React from 'react'
import styles from './Group.module.css'

import PropTypes from 'prop-types'

import {
  TextField,
  Button,
} from '@material-ui/core'

class GroupForm extends React.Component {
  render () {
    return (
      <div>
        <form onSubmit={(event) => {
          event.preventDefault()
          this.props.submit()
        }}>
          <TextField
            autoComplete="off"
            className={styles.textFields}
            variant="outlined"
            size="small"
            name="name"
            fullWidth
            label="Name"
            onChange={this.props.onchange}
            value={this.props.item.name}
            id="group-name"
          />
          <p className={styles.error}>{this.props.error}</p>
        </form>
        {this.props.children}
        <div className={styles.actionButton}>
          <Button type='submit' variant="outlined" disabled={!this.props.item.name} id="group-submit" color="primary" onClick={() => this.props.submit()} >Save</Button>
        </div>
      </div>
    )
  }
}
export default GroupForm

GroupForm.propTypes = {
  classes: PropTypes.object,
  onchange: PropTypes.func,
  item: PropTypes.object,
  children: PropTypes.object,
  submit: PropTypes.func,
  error: PropTypes.func
}
